import React from 'react';

/* eslint-disable max-len */
const CaretDown = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "14",
    height: "8",
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.4599L1.20935 1.66925C0.92688 1.38678 0.92688 0.963074 1.20935 0.680603C1.49182 0.398132 1.91553 0.398132 2.198 0.680603L7 5.4826L11.802 0.680603C12.0845 0.398132 12.5082 0.398132 12.7906 0.680603C13.0731 0.963074 13.0731 1.38678 12.7906 1.66925L7 7.4599Z",
    fill: "#323254"
  }));
};

export { CaretDown };
